export const APP_LOG = {
    JWT: {
        ERROR_PARSE: 'Error parse jwt token'
    }
}

export default APP_LOG;